import React, { useEffect, useState } from 'react';
import { isEqual } from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { BrowserRouter } from 'react-router-dom';
import { Spin } from 'antd';

import { permissions, user } from '../../store/selectors/user';
import { startSession } from '../../store/actions/session';

import ForbiddenPage from '../../components/ForbiddenPage';

const style = {
  spinContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
};

const renderSpin = () => (
  <div style={style.spinContainer}>
    <Spin size="large" />
  </div>
);

const InitialLoading = ({ children, permissions, user, startSession }) => {
  const [isLoading, setLoading] = useState(true);
  useEffect(() => {
    startSession();
  }, [startSession]);

  useEffect(() => {
    if (!permissions.length) {
      return;
    }

    const prevPermissions = JSON.parse(localStorage.getItem('permissions'));
    if (!isEqual(prevPermissions, permissions)) {
      localStorage.setItem('permissions', JSON.stringify(permissions));
      localStorage.setItem('filters', JSON.stringify([]));
    }
    setLoading(false);
  }, [permissions]);

  if (isLoading || (!permissions.length && !user)) {
    return renderSpin();
  }

  return permissions.length ? (
    children
  ) : (
    <BrowserRouter>
      <ForbiddenPage withButton={false} />
    </BrowserRouter>
  );
};

InitialLoading.propTypes = {
  children: PropTypes.node.isRequired,
  permissions: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.string,
  ]),
  startSession: PropTypes.func.isRequired,
  user: PropTypes.string.isRequired,
};

InitialLoading.defaultProps = {
  permissions: [],
};

const mapStateToProps = state => {
  return {
    permissions: permissions(state),
    user: user(state),
  };
};

export default connect(mapStateToProps, { startSession })(InitialLoading);
